import { RootState } from '../root.reducer'

export const selectLoginThrottle = (state: RootState) => state.loginThrottle

export const selectIsBlocked = (state: RootState) =>
  state.loginThrottle.blockedUntil !== null &&
  Date.now() < state.loginThrottle.blockedUntil
